<template>
    <div
    class="modal right fade trader-info"
    id="add-scheduler"
    tabindex="-1"
    role="dialog"
    aria-labelledby="addSchedulerLabel"
    aria-hidden="true"
    >
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="addSchedulerLabel">Add Scheduler</h5>
            <button type="button" class="close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form @submit.prevent="">
                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <div class="form-group scheduler-customers">
                    <label>Customers</label>
                    <multiselect
                        v-model="selectedCustomers"
                        placeholder="Select Customers"
                        :options="customerList"
                        :multiple="true"
                        :close-on-select="false"
                        :custom-label="customerLabel"
                        track-by="id">
                    </multiselect>
                </div>
                <div class="modal-footer bid scheduler-footer">
                    <button type="button" class="btn btn-secondary" @click="$emit('close')">Close</button>
                    <button type="button" class="btn btn-primary" :disabled="!selectedCustomers.length || saving" @click="addScheduler()">
                        <i v-if="saving" class="fa fa-spinner fa-spin"></i> ADD
                    </button>
                </div>
            </form>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
import authService from "@/authService";
import config from "@/config";

export default {
  name: "reportAddSchedulerModal",
  data () {
    return {
      loading: false,
      saving: false,
      customerList: [],
      selectedCustomers: []
    };
  },
  methods: {
    customerLabel (customer) {
      const first = customer.customerFirstName ? customer.customerFirstName[0] + ". " : "";
      return first + (customer.customerLastName || "");
    },
    getCustomers () {
      this.loading = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlAutoBidder + "/customer/name-list",
          auth
        )
        .then(result => {
          const data = result.data;
          this.customerList = Array.isArray(data) ? data : (data && data.content) || [];
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    addScheduler () {
      this.saving = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() }
      };
      const data = {
        deletedIds: [],
        createdBy: authService.getUser().id,
        customerIds: this.selectedCustomers.map(c => c.id)
      };
      this.$http
        .post(config.baseUrlAutoBidder + "/eod/email-scheduler", data, auth)
        .then(() => {
          this.saving = false;
          this.$alert("Scheduler added successfully", "", "success");
          this.$emit("saved");
        })
        .catch(e => {
          console.log(e);
          this.saving = false;
          this.$alert("Failed to add scheduler", "", "error");
        });
    }
  },
  mounted () {
    this.getCustomers();
  }
};
</script>

<style scoped>
.scheduler-customers {
  max-width: 520px;
  margin: 0 auto;
  text-align: left;
}
.scheduler-footer {
  justify-content: center;
  padding: 1.5rem 0 0.5rem;
  border-top: none;
}
.scheduler-footer .btn {
  min-width: 110px;
  padding: 0.6rem 1.5rem;
  margin: 0 0.4rem;
}
</style>
